import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKpis = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 4,
			fill: "#161957"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.818 13.1906H10.1816C10.1816 12.7738 10.354 12.3741 10.6609 12.0794C10.9678 11.7847 11.384 11.6191 11.818 11.6191H28.1816C28.6156 11.6191 29.0318 11.7847 29.3387 12.0794C29.6456 12.3741 29.818 12.7738 29.818 13.1906Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.6365 10.5714H12.3638C12.3638 10.1547 12.5362 9.75496 12.843 9.46026C13.1499 9.16556 13.5661 9 14.0001 9H26.0001C26.4341 9 26.8503 9.16556 27.1572 9.46026C27.4641 9.75496 27.6365 10.1547 27.6365 10.5714Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3636 14.2383H9.63636C9.20237 14.2383 8.78616 14.4038 8.47928 14.6985C8.1724 14.9932 8 15.3929 8 15.8097V29.4288C8 29.8455 8.1724 30.2452 8.47928 30.5399C8.78616 30.8346 9.20237 31.0002 9.63636 31.0002H30.3636C30.7976 31.0002 31.2138 30.8346 31.5207 30.5399C31.8276 30.2452 32 29.8455 32 29.4288V15.8097C32 15.3929 31.8276 14.9932 31.5207 14.6985C31.2138 14.4038 30.7976 14.2383 30.3636 14.2383Z",
			fill: "url(#paint0_linear_11486_245932)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.75 21.5C15.3358 21.5 15 21.1642 15 20.75C15 20.3358 15.3358 20 15.75 20L24.25 20C24.6642 20 25 20.3358 25 20.75C25 21.1642 24.6642 21.5 24.25 21.5L15.75 21.5Z",
			fill: "#F8F8FF"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_11486_245932",
			x1: 5.5,
			y1: 32,
			x2: 23.1821,
			y2: 7.70285,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .00183952,
					stopColor: "#53BCDE"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .515571,
					stopColor: "#767CFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#AC8EFF"
				})
			]
		}) })
	]
});
export default SvgKpis;
